import { appConfig } from '../config/app';
import { IApiList, IEmployer, IEmployerResponse, IListEmployersOptions, ISite } from '../types';
import { ApiClient, IApiQueryOptions } from './ApiClient';

export const Employers = {
  listEmployers: (options?: IListEmployersOptions) =>
    ApiClient.get<IEmployerResponse>(`${appConfig.API_BASE_URL}/v1/employers?include_action_required=${!!options?.includeActionRequired}&include_dismissed=${!!options?.includeDismissed}&include_salesforce=${!!options?.includeSalesforce}`),
  showEmployerById: (employerId: string) => ApiClient.get<IEmployer>(`${appConfig.API_BASE_URL}/v1/employers/${employerId}`),
  listEmployerSites: (organizationId: string, options?: IApiQueryOptions) => ApiClient.get<IApiList<ISite>>(`${appConfig.API_BASE_URL}/v1/employers/${organizationId}/sites`, options),
};
